import { IRequestConfig, MethodsTypes } from 'models/Axios';
import axios from 'axios';
import buildQuery from 'odata-query';
import { ICustomer } from 'models/Customer';
import Services from './index.service';

export default class CompanyService extends Services<any, any> {
  public async autoComplete(str: any, legalPerson: string = '') {
    const config: IRequestConfig<any> = {
      url: `${this.base_url}/company/autocomplete?sentence=${str}&legalPersonType=${legalPerson}`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return await axios(config)
      .then((result) => result.data)
      .catch(() => []);
  }

  public get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: {}
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<ICustomer> = {
      url: `/company`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
        $filter: filterQuery.split('=')[1] || undefined,
      },
    };

    return this.httpRequest(config);
  };

  public findById = (id: string) => {
    const config: IRequestConfig<ICustomer> = {
      url: `/company/${id}`,
    };

    return this.httpRequest(config);
  };

  getRegulatoryDocuments = (
    filter?: {}
  ) => {
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<ICustomer> = {
      url: `/regulatory-documents${filterQuery}`,
      params: {
        $top: 100
      },
    };

    return this.httpRequest(config);
  };

  getRegulatoryDocumentBlobUrl = ( id: string ) => {

    const config: IRequestConfig<ICustomer> = {
      url: `/regulatory-documents/blob/${id}`
    };

    return this.httpRequest(config);

  }
}
